<!-- while the froala editor initializes, it is layered invisibly over the still
     visible static preview. the swap only happens once froala fired "initialized",
     so there is no flicker between fake and real editor -->
<div [qaTemplateVariableHighlight]="allowVariables" [qaTemplateVariableLabels]="variableLabels"
     (qa-condition-edit)="editCondition($event)" (qa-variable-edit)="editVariable($event)"
     class="qa-lazy-froala-host" [ngClass]="{'qa-lazy-froala-initializing': active && !ready, 'qa-block-froala': block}">
  <div
    *ngIf="active"
    [froalaEditor]="wrappedOptions"
    [froalaModel]="model"
    (froalaModelChange)="onModelChange($event)"
    (blur)="blur.emit($event)"
  ></div>

  <!-- static preview of the wysiwyg content. the real editor initializes on first interaction.
       froalaView renders the content exactly like froala does (no angular sanitizing, fr-view class).
       block fields reuse froala's own box markup plus a snapshot of the real toolbar -->
  <div
    *ngIf="!ready"
    class="qa-lazy-froala-static"
    [ngClass]="{'fr-box fr-basic fr-top': block}"
    (mousedown)="activate(true, $event)"
  >
    <div *ngIf="block" class="qa-lazy-froala-toolbar-preview" aria-hidden="true" [innerHTML]="toolbarPreviewHtml"></div>
    <div [ngClass]="{'fr-wrapper': block}">
      <div
        class="qa-lazy-froala fr-element"
        [attr.data-placeholder]="options && options.placeholderText"
        [froalaView]="model || ''"
        tabindex="0"
        (focus)="activate()"
      ></div>
    </div>
    <div *ngIf="block" class="fr-second-toolbar"></div>
  </div>
</div>
